import { FCC } from "@/types/common";
import { Stack, Typography } from "@mui/material";
import { InnerBox } from "@/components/elements/InnerBox";
import { divider } from "@/theme/colors";
import { TGetPartnerDto } from "@/api/services/main/partner/dtos/get-partner.dto";
import { PartnerInfoItem } from "@/features/partner/components/partner-detail/PartnerInfoItem";

type TPartnerContractInfoProps = {
  partner: TGetPartnerDto;
};

export const PartnerContractInfo: FCC<TPartnerContractInfoProps> = ({ partner }) => {
  return (
    <InnerBox title={<Typography variant="sub16Bold">契約情報</Typography>} showDivider={false} borderColor={divider.high} sx={{ gap: "24px" }}>
      <Stack direction="row" alignItems="flex-start" gap={3}>
        <PartnerInfoItem label="契約情報" value={partner.contractInfo} type="textArea" showDivider={false} />
        <PartnerInfoItem label="請求情報" value={partner.billingInfo} type="textArea" showDivider={false} />
      </Stack>
    </InnerBox>
  );
};
